<template>
  <div :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}">
    <feather-icon icon="CopyIcon" svgClasses="h-5 w-5 mr-4 text-primary hover:text-success cursor-pointer" @click="openResource" />
  </div>
</template>

<script>

    export default {
        name: 'CellRendererActions',
        computed: {
        },
        methods: {
            openResource() {
                // alert(this.params.data.screenshot)
                this.$parent.$parent.isPopup= true
                this.$parent.$parent.screenshot = this.params.data.screenshot
                // alert(this.$parent.$parent.screenshot)
            },
        }
    }
</script>

<style lang="scss" scpoped>
  .ag-grid-cell-chip {
    &.vs-chip-success {
      background: rgba(var(--vs-success), .15);
      color: rgba(var(--vs-success), 1) !important;
      font-weight: 500;
    }

    &.vs-chip-warning {
      background: rgba(var(--vs-warning), .15);
      color: rgba(var(--vs-warning), 1) !important;
      font-weight: 500;
    }

    &.vs-chip-danger {
      background: rgba(var(--vs-danger), .15);
      color: rgba(var(--vs-danger), 1) !important;
      font-weight: 500;
    }
  }
</style>
